import React from 'react';
import AdminSidebar from './AdminSidebar';
import ClientSidebar from './ClientSidebar';
import { User } from '../../types';

interface Props {
  user: User;
}

const Sidebar = ({ user }: Props) => {
  const userType = localStorage.getItem('userType');

  return userType === 'ADMIN' ? (
    <AdminSidebar user={user} />
  ) : (
    <ClientSidebar user={user} />
  );
};

export default Sidebar;
